import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { scrollToFirstError } from '../../../../../../../../shared/utils/uiEffects/scrollTo';

import FamilySituationInput from './components/FamilySituationInput';
import PersonalAddressInput from './components/PersonalAddressInput';
import CoOwnershipInput from './components/CoOwnershipInput';

import { RadioInput, TextInput, PhoneNumberInput, DatePickerInput, Button } from 'hosman-material';

import { getUser } from '../../../../../../../reducers/App/userSlice';
import { updateOnboardedUser, updateSaleBuyingYear, updateErrors, submitCoordinates } from '../../../../../../../reducers/SellerApp/mandatesSlice';

const Coordinates = () => {
  const { user } = useSelector((state) => state.user);
  const { sale } = useSelector((state) => state.sellerSales);
  const { onboardedUser, saleBuyingYear, isSubmitting, errors, stateReady } = useSelector((state) => state.sellerMandates);
  const dispatch = useDispatch();

  useEffect(() => { dispatch(getUser()) }, []);

  useEffect(() => {
    if (!user) return;

    dispatch(updateOnboardedUser({
      civility: user.civility,
      first_name: user.first_name,
      last_name: user.last_name,
      email: user.email,
      phone_number: user.phone_number,
      phone_country_code: user.phone_country_code,
      birth_date: user.birth_date,
      family_situation: user.family_situation,
      co_ownership: user.co_ownership,
      co_ownership_kind: user.co_ownership_kind,
      co_ownership_name: user.co_ownership_name,
      physical_address_attributes: user.physical_address
    }))
  }, [user]);

  useEffect(() => {
    if (!sale.buying_year) return;

    dispatch(updateSaleBuyingYear(sale.buying_year.toString()))
  }, [sale]);

  const handleUserChange = (e) => {
    const { name, value } = e.target
    dispatch(updateErrors({ ...errors, [name]: null}))
    dispatch(updateOnboardedUser({ ...onboardedUser, [name]: value }))
  };

  const handleBuyingYearChnage = (e) => {
    dispatch(updateErrors({ ...errors, buying_year: null}))
    dispatch(updateSaleBuyingYear(e.target.value))
  };

  const handleSubmit = () => {
    dispatch(submitCoordinates(sale.id))

    setTimeout(() => {
      scrollToFirstError();
    }, 300);
  }

  if (!stateReady) return;

  return (
    <div className='flex flex-col gap-8 text-ih-indigo' data-testid='Coordinates'>
      <p className='h3'>Vos coordonnées :</p>

      <div className='flex flex-col gap-5'>
        <RadioInput
          label='État civil :'
          name='civility'
          options={[
            { name: 'Monsieur', value: 'mr' },
            { name: 'Madame', value: 'mrs' }
          ]}
          value={onboardedUser.civility}
          onChange={(val) => handleUserChange({ target: { name: 'civility', value: val }})}
          errors={errors}
        />

        <div className='flex flex-col md:flex-row gap-3'>
          <TextInput label='Prénom' name='first_name' value={onboardedUser.first_name} onChange={handleUserChange} errors={errors} />
          <TextInput label='Nom' name='last_name' value={onboardedUser.last_name} onChange={handleUserChange} errors={errors} />
        </div>

        <TextInput label='E-mail' name='email' value={onboardedUser.email} disabled />

        <PhoneNumberInput
          onChangePhone={(val) => handleUserChange({ target: { name: 'phone_number', value: val }})}
          onChangeCountryCode={(val) => handleUserChange({ target: { name: 'phone_country_code', value: val }})}
          phoneValue={onboardedUser.phone_number || user.phone_number }
          countryCodeValue={onboardedUser.phone_country_code || user.phone_country_code }
          errors={errors}
        />

        <div className='flex flex-col md:flex-row justify-between gap-5'>
          <div className='md:w-1/2'>
            <DatePickerInput name='birth_date' label='Date de naissance' value={onboardedUser.birth_date} onChange={handleUserChange} errors={errors} />
          </div>
          <div className='md:w-1/2'>
            <FamilySituationInput familySituation={onboardedUser.family_situation} setFamilySituation={handleUserChange} errors={errors} />
          </div>
        </div>

        <div>
          <p className='font-semibold text-ih-indigo mb-3'>Depuis quand êtes-vous propriétaire de ce bien ?</p>

          <div className='md:w-1/2'>
            <TextInput
              name='buying_year'
              placeholder='2018'
              value={saleBuyingYear}
              onChange={handleBuyingYearChnage}
              errors={errors}
            />
          </div>
        </div>
      </div>

      <PersonalAddressInput />

      <CoOwnershipInput />

      <div className='md:flex justify-end'>
        <Button label='Étape suivante' onClick={() => handleSubmit()} isLoading={isSubmitting} />
      </div>
    </div>
  );
}

export default Coordinates;
